export const RightIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="36"
      height="28"
      viewBox="0 0 36 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 14H34M34 14L22 2M34 14L22 26"
        stroke={props.color || 'black'}
        strokeWidth={props.strokeWidth || '4'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
